import { ZodError } from 'zod';

/** Display decimal text without passing NUMERIC values through binary floating point. */
export function quantityText(value: unknown): string {
  if (value === null || value === undefined || value === '') return 'Unknown';
  const raw = String(value);
  const match = /^(-?)(\d+)(\.\d+)?$/.exec(raw);
  if (!match) return raw;
  return `${match[1]}${match[2].replace(/\B(?=(\d{3})+(?!\d))/g, ',')}${match[3] ?? ''}`;
}

export function dateText(value: string | null | undefined): string {
  // The API serializes some SQL DATEs as ISO timestamps. Preserve the calendar date.
  return value ? value.slice(0, 10) : 'Unknown';
}

export function pageNumber(value: string | null): number {
  const parsed = Number(value);
  return Number.isSafeInteger(parsed) && parsed > 0 ? parsed : 1;
}

export function displayText(value: unknown): string {
  return value === null || value === undefined || value === '' ? 'Unknown' : String(value);
}

export function statusText(value: string): string {
  return value.replaceAll('_', ' ');
}

export const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function requestFailure(cause: unknown, fallback = 'Records could not be loaded.'): string {
  if (cause instanceof ZodError)
    return 'The server returned an incomplete or unexpected record. Refresh to retry.';
  return cause instanceof Error ? cause.message : fallback;
}
